import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Select,
  Table,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import FileUpload from "../../../documenti/FileUpload";
import { useState } from "react";
import { Add } from "@mui/icons-material";
import { Eye } from "react-feather";

const Documenti = ({ documenti }) => {
  const [file, setFile] = useState(null);
  const [rows, setRows] = useState(documenti || []);

  const handleRowFileUpload = (idUid, files) => {
    const uploadedFile = files[0];
    setRows((prev) =>
      prev.map((row) =>
        row.idUidDocumento === idUid ? { ...row, file: uploadedFile } : row,
      ),
    );
  };

  const handleViewFile = (file) => {
    if (!file) {
      alert("Nessun file caricato per questo documento.");
      return;
    }

    const fileURL = URL.createObjectURL(file);
    const newWindow = window.open(fileURL, "_blank");
    newWindow?.addEventListener("unload", () => URL.revokeObjectURL(fileURL));
  };

  const AddRow = () => {
    setRows((prev) => [
      ...prev,
      {
        idUidDocumento: `new-${prev.length + 1}`,
        nome: "Nuovo Documento",
        tipo: "Opzionale",
        fonte: "Upload",
        descrizione: "",
        abilitato: 1,
        file: null,
      },
    ]);
  };

  //Più a destra del documento, il nome è ha la funzione del vedere il documento, tutto su una riga. Caricato e data saranno sotto al nome. La colonna id non c'è, nome -> documento e azioni -> file
  //Documenti opzionali nella select, sempre con l'icona di eliminazione

  /* const handleSave = async () => {
    setLoadingPage(true);
    // Error checks
    const newErrors = {
      nome: form.nome === "",
      file:
        savedIdUidFile === ""
          ? form.tipo.value === 2 && form.fonte.value === 3 && !file
          : false,
      link: form.tipo.value === 2 && form.fonte.value === 2 && !form.link,
      autoGenerato:
        form.tipo.value === 2 &&
        form.fonte.value === 1 &&
        form.autoGenerati.value === "",
    };

    setErrors(newErrors);

    // If any error, show snackbar and stop
    if (Object.values(newErrors).some(Boolean)) {
      handleSnackbar("Compila tutti i campi obbligatori.", "error");
      return;
    }

    const payload = {
      idUID: iduid,
      nome: form.nome.trim(),
      descrizione: form.descrizione.trim(),
      fonte: form.fonte.value,
      tipo: form.tipo.value,
      tipologia: form.tipologie.value,
      link: form.link.trim(),
      idUidFile: form.idUidFile,
      idAutoGenerato:
        form.autoGenerati.value === "" ? 0 : form.autoGenerati.value,
    };

    console.log(payload);

    if (rows !== undefined) {
      const documentoExists = (doc) => {
        return rows.some(
          (row) =>
            row.nome.trim().toLowerCase() === doc.nome.trim().toLowerCase()
        );
      };

      if (documentoExists(payload)) {
        handleSnackbar("Documento già esistente, cambiare il nome", "error");
        setLoadingPage(false);
        return;
      }
    }

    const formData = new FormData();
    const token = sessionStorage.getItem("token");

    formData.append("data", JSON.stringify(payload));
    formData.append("file", "");

    // Only append file if fonte === 3
    if (form.tipo.value === 2 && form.fonte.value === 3 && file) {
      formData.set("file", file);
    }

    formData.forEach((value, key) => {
      console.log(`${key}:`, value);
    });

    try {
      // Uncomment to enable API call
      const response = await fetch(`${API_BASE_URL}/api/documentiNewUpdate`, {
        method: "POST",
        headers: {
          authorization: "Bearer " + token,
        },
        body: formData,
      });

      const responseData = await response.json();

      if (responseData.status === -1) {
        navigate("/auth/sign-in");
      }
      if (responseData.status === 0) {
        handleSnackbar(responseData.message, "error");
        return;
      }
      if (responseData.status === 1) {
        handleSnackbar(responseData.message, "success");
        const documento = {
          ...payload,
          idUidDocumento: responseData.data.idUid,
          tipo: payload.tipo === 1 ? "Richiesto" : "Contratto",
          fonte:
            payload.fonte === 1
              ? "Autogenerato"
              : payload.fonte === 2
              ? "Link"
              : payload.fonte === 3
              ? "File"
              : "",
          abilitato: 0,
        };
        delete documento.idUID;

        if (addDocumentoToRows !== undefined && iduid === "") {
          if (!addDocumentoToRows(documento)) {
            setLoadingPage(false);
            return;
          }
        }
        if (modifyDocumento !== undefined && iduid !== "") {
          if (!modifyDocumento(documento)) {
            setLoadingPage(false);
            return;
          }
        }
      }
      setLoadingPage(false);
      handleClose();
      if (onRefresh) onRefresh();
    } catch (error) {
      console.log(error);
      handleSnackbar("Errore durante il salvataggio.", "error");
      setLoadingPage(false);
      handleClose();
    }
  }; */

  console.log(file);

  return (
    <Box display="flex" flexDirection="column" gap={4} width="100%">
      <Box
        display="flex"
        justifyContent="space-between"
        gap={4}
        width="100%"
        alignItems="center"
      >
        <FormControl size="small" margin="none" fullWidth>
          <InputLabel id="tipologia-label">Tipologia</InputLabel>
          <Select
            labelId="tipologia-label"
            id="tipologia"
            name="tipologia"
            label="Tipologia"
            value=""
            /*    MenuProps={MenuProps} */
          >
            {/* {tipologie.map((tipo) => (
                  <MenuItem key={tipo.value} value={tipo.value}>
                    {tipo.label}
                  </MenuItem>
                ))} */}
          </Select>
        </FormControl>
        <Button onClick={AddRow} variant="contained">
          Aggiungi
        </Button>
      </Box>
      <Box
        sx={{
          maxHeight: 400,
          overflowY: "auto",
          width: "100%",
          border: "1px solid #929292ff",
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Documento</TableCell>
              <TableCell>Upload</TableCell>
            </TableRow>
          </TableHead>
          {rows.map((el) => (
            <TableRow key={el.idUidDocumento}>
              <TableCell>
                <Box sx={{ color: "green", fontWeight: "bold" }}>{el.nome}</Box>
                {el.descrizione && (
                  <Box sx={{ fontSize: "0.8rem", mt: 0.5 }}>
                    {el.descrizione}
                  </Box>
                )}
              </TableCell>
              <TableCell>
                <Box display="flex" alignItems="center" gap={1}>
                  {el.link ? (
                    <IconButton
                      color="secondary"
                      onClick={() => window.open(el.link, "_blank")}
                    >
                      <Eye size={20} />
                    </IconButton>
                  ) : (
                    <FileUpload
                      onFileAccepted={(files) =>
                        handleRowFileUpload(el.idUidDocumento, files)
                      }
                      trigger={({ open }) => (
                        <IconButton color="primary" onClick={open}>
                          <Add />
                        </IconButton>
                      )}
                    />
                  )}
                  {el.file && (
                    <Button
                      onClick={() => handleViewFile(el.file)}
                      variant="outlined"
                      size="small"
                    >
                      {el.file.name.length > 15
                        ? el.file.name.substring(0, 12) + "..."
                        : el.file.name}
                    </Button>
                  )}
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </Box>
    </Box>
  );
};

export default Documenti;
